<div class="header-bar">
  <h1>Invoice Addresses</h1>
</div>
<div class="content-container">
  <div class="invoice-address-list-container">
    <div class="">
      <p-dataView
        #dv
        [value]="page.items"
        [paginator]="page.total > 10"
        [rows]="10"
        [rowsPerPageOptions]="[10, 20, 30, 40, 50]"
        [lazy]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [totalRecords]="page.total"
        [loading]="loading"
        filterBy="invoiceCompanyName"
      >
        <p-header [style]="">
          <div class="ui-helper-clearfix">
            <div class="ui-g">
              <div class="ui-g-3 ui-md-3 ui-sm-12">
                <p-dropdown
                  [options]="sortOptions"
                  [(ngModel)]="sortKey"
                  placeholder="Sort By"
                  (onChange)="onSortChange($event)"
                  [autoWidth]="false"
                >
                  <ng-template let-option pTemplate="item">
                    <div class="ui-helper-clearfix dropdown-options">
                      <div>{{ option.label }} <span class="{{ option.icon }}"></span></div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="ui-g-3 ui-md-3 ui-sm-12 filter-container">
                <organisation-select-list
                  [minTextLength]="1"
                  [selectedOrganisationId]="customerorgId"
                  *ngIf="isVmeMode"
                  (valueChange)="onOrganisationChange($event)"
                >
                </organisation-select-list>
              </div>
              <div class="ui-g-3 ui-md-3 ui-sm-12 filter-container">
                <div class="hide">
                  <input
                    type="search"
                    pInputText
                    placeholder="Filter by company name"
                    (keyup)="dv.filter($event.target.value)"
                  />
                </div>
              </div>
              <div class="ui-g-3 ui-md-3 ui-sm-12 pull-right">
                <button
                  ngClass="pull-right"
                  pButton
                  type="button"
                  icon="pi pi-plus"
                  (click)="createNew($event)"
                  label="Create new"
                ></button>
              </div>
            </div>
          </div>
        </p-header>
        <ng-template let-ia pTemplate="listItem">
          <p-panel class="invoice-address-list-panel ui-g-12" [showHeader]="false">
            <p-footer>
              <div class="ui-helper-clearfix">
                <div class="ui-sm-12 ui-md-4 ui-g-4">
                  <span class="ui-panel-title ui-sm-12" *ngIf="ia.organisationName"
                    ><i>for </i><b>{{ ia.organisationName }}</b></span
                  >&nbsp;
                  <small *ngIf="ia.isApproved" class="text-success"
                    ><span>Approved <i class="pi pi-check"></i></span
                  ></small>
                  <small *ngIf="!ia.isApproved" class="text-warning"
                    ><span>Awaiting Approval <i class="pi pi-clock"></i></span
                  ></small>
                </div>
                <div class="ui-sm-12 ui-md-8 ui-g-8">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    label="Remove"
                    ngClass="ui-button-danger pull-right mt-1 ui-sm-5"
                    [disabled]="ia.organisations.length > 0 || ia.customerDepartments.length > 0"
                    (click)="delete($event, ia)"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    label="Modify"
                    ngClass="pull-right ui-button-warning mt-1 ui-sm-5"
                    (click)="modifyInvoiceAddress($event, ia)"
                  ></button>
                  <button
                    *ngIf="!ia.isApproved && isVmeMode"
                    ngClass="pull-right ui-button-success mt-1 ui-sm-5"
                    pButton
                    type="button"
                    (click)="approve($event, ia)"
                    icon="pi pi-check"
                    label="Approve"
                  ></button>
                  <button
                    *ngIf="ia.isApproved && isVmeMode"
                    ngClass="pull-right ui-button-default ui-button-secondary mt-1 ui-sm-5"
                    pButton
                    type="button"
                    (click)="disapprove($event, ia)"
                    icon="pi pi-ban"
                    label="Disapprove"
                  ></button>
                  <button
                    ngClass="pull-right ui-button-primary mt-1 ui-sm-5"
                    pButton
                    type="button"
                    icon="pi pi-clock"
                    label="View History"
                    (click)="getHistory($event, ia)"
                  ></button>
                </div>
              </div>
            </p-footer>
            <div class="ui-g invoice-address-section">
              <p-card
                title="Invoice Contact(s) & Address"
                ngClass="invoice-address-details"
                [className]="isVmeMode ? 'ui-g-12 ui-md-4' : 'ui-g-12 ui-md-6'"
              >
                <h3 style="margin-top: 5px; margin-bottom: 5px">Invoice Contact(s) & Address</h3>

                <div class="ui-g address-details">
                  <p-fieldset
                    class="ui-g-12"
                    legend="Contact 1"
                    *ngIf="
                      hasValue(ia.invoiceContactFirstName) || hasValue(ia.invoiceContactLastName)
                    "
                  >
                    <div
                      class="ui-g-12 ui-sm-12"
                      *ngIf="
                        hasValue(ia.invoiceContactFirstName) || hasValue(ia.invoiceContactLastName)
                      "
                      title="Contact 1 Name"
                    >
                      <i class="pi pi-user"></i>
                      <b class="ia-address-value"
                        >{{ ia.invoiceContactFirstName }} {{ ia.invoiceContactLastName }}</b
                      >
                    </div>
                    <div
                      class="ui-g-12 ui-sm-12"
                      *ngIf="hasValue(ia.invoiceContactEmail)"
                      title="Contact 1 Email"
                    >
                      <i class="pi pi-envelope"></i>
                      <b class="ia-address-value">{{ ia.invoiceContactEmail }}</b>
                    </div>
                    <div
                      class="ui-g-12 ui-sm-12"
                      *ngIf="hasValue(ia.invoiceContactPhone)"
                      title="Contact 1 Phone"
                    >
                      <i class="pi pi-mobile"></i>
                      <b class="ia-address-value">{{ ia.invoiceContactPhone }}</b>
                    </div>
                  </p-fieldset>

                  <p-fieldset
                    class="ui-g-12"
                    legend="Contact 2"
                    *ngIf="
                      hasValue(ia.invoiceContact2FirstName) || hasValue(ia.invoiceContact2LastName)
                    "
                  >
                    <div
                      class="ui-g-12 ui-sm-12"
                      *ngIf="
                        hasValue(ia.invoiceContact2FirstName) ||
                        hasValue(ia.invoiceContact2LastName)
                      "
                      title="Contact 2 Name"
                    >
                      <i class="pi pi-user"></i
                      ><b class="ia-address-value"
                        >{{ ia.invoiceContact2FirstName }} {{ ia.invoiceContact2LastName }}</b
                      >
                    </div>
                    <div
                      class="ui-g-12 ui-sm-12"
                      *ngIf="hasValue(ia.invoiceContact2Email)"
                      title="Contact 2 Email"
                    >
                      <i class="pi pi-envelope"></i
                      ><b class="ia-address-value">{{ ia.invoiceContact2Email }}</b>
                    </div>
                  </p-fieldset>

                  <p-fieldset
                    class="ui-g-12"
                    legend="Contact 3"
                    *ngIf="
                      hasValue(ia.invoiceContact3FirstName) || hasValue(ia.invoiceContact3LastName)
                    "
                  >
                    <div
                      class="ui-g-12 ui-sm-12"
                      *ngIf="
                        hasValue(ia.invoiceContact3FirstName) ||
                        hasValue(ia.invoiceContact3LastName)
                      "
                      title="Contact 3 Name"
                    >
                      <i class="pi pi-user"></i
                      ><b>{{ ia.invoiceContact3FirstName }} {{ ia.invoiceContact3LastName }}</b>
                    </div>
                    <div
                      class="ui-g-12 ui-sm-12"
                      *ngIf="hasValue(ia.invoiceContact3Email)"
                      title="Contact 3 Email"
                    >
                      <i class="pi pi-envelope"></i><b>{{ ia.invoiceContact3Email }}</b>
                    </div>
                  </p-fieldset>

                  <p-fieldset class="ui-g-12" legend="Address">
                    <div class="ui-g-12" title="Invoice Company Name">
                      <b class=""> {{ ia.invoiceCompanyName }}</b>
                    </div>
                    <div class="ui-g-12" title="Address Line 1">
                      <b class=""> {{ ia.addressLine1 }}</b>
                    </div>
                    <div class="ui-g-12" title="Address Line 2">
                      <b class=""> {{ ia.addressLine2 }}</b>
                    </div>
                    <div class="ui-g-12" title="Address Line 3">
                      <b class=""> {{ ia.addressLine3 }}</b>
                    </div>
                    <div class="ui-g-12" title="Town">
                      <b class=""> {{ ia.town }}</b>
                    </div>
                    <div class="ui-g-12" title="Post Code">
                      <b class=""> {{ ia.postCode | postcode }}</b>
                    </div>
                    <div class="ui-g-12" title="Country">
                      <b class=""> {{ ia.country }}</b>
                    </div>
                  </p-fieldset>
                </div>
              </p-card>
              <p-card
                *ngIf="isVmeMode"
                title="Billing Settings"
                class="ui-g-12 ui-md-4 invoice-address-details"
              >
                <ul class="ui-g style-1">
                  <li class="ui-g-12">
                    <div class="ui-g-5 ui-sm-6">Invoice Period:</div>
                    <div class="ui-g-7 ui-sm-6 detail-value">
                      <b> {{ ia.invoicePeriod }}</b>
                    </div>
                  </li>
                  <li class="ui-g-12">
                    <div class="ui-g-5 ui-sm-6">Purchase Order Number:</div>
                    <div class="ui-g-7 ui-sm-6 detail-value">
                      <b> {{ ia.purchaseOrderNumber }}</b>
                    </div>
                  </li>
                  <li class="ui-g-12">
                    <div class="ui-g-5 ui-sm-6">Xero Payment Terms Type:</div>
                    <div class="ui-g-7 ui-sm-6 detail-value">
                      <b> {{ ia.paymentTermsType }}</b>
                    </div>
                  </li>
                  <li class="ui-g-12">
                    <div class="ui-g-5 ui-sm-6">Xero Payment Terms Days:</div>
                    <div class="ui-g-7 ui-sm-6 detail-value">
                      <b> {{ ia.paymentTermsDays }}</b>
                    </div>
                  </li>
                  <li class="ui-g-12">
                    <div class="ui-g-5 ui-sm-6">Xero Contact ID:</div>
                    <div class="ui-g-7 ui-sm-6 detail-value">
                      <b> {{ ia.xeroContactId }}</b>
                    </div>
                  </li>
                  <li class="ui-g-12">
                    <div class="ui-g-5 ui-sm-6">Revolut Counter Party ID:</div>
                    <div class="ui-g-7 ui-sm-6 detail-value">
                      <b> {{ ia.revolutCounterpartyId }}</b>
                    </div>
                  </li>
                  <li class="ui-g-12">
                    <div class="ui-g-5 ui-sm-6">Billing Wait Days:</div>
                    <div class="ui-g-7 ui-sm-6 detail-value">
                      <b> {{ ia.billingWaitDays }}</b>
                    </div>
                  </li>
                </ul>
              </p-card>
              <p-card
                title="Used by"
                *ngIf="ia.organisations.length > 0 || ia.customerDepartments.length > 0"
                [className]="isVmeMode ? 'ui-g-12 ui-md-4' : 'ui-g-12 ui-md-6'"
              >
                <h3 style="margin-top: 5px; margin-bottom: 5px">Used By</h3>

                <div class="ui-g">
                  <div *ngIf="ia.organisations.length > 0" class="ui-g-12">
                    <span
                      ><b>{{
                        ia.organisations.length > 1 ? 'Organisations' : 'Organisation'
                      }}</b></span
                    >
                    <ul class="ui-g-12 style-1">
                      <li class="ui-g-12" *ngFor="let item of ia.organisations; let i = index">
                        <div class="ui-g-8">{{ item.name }}</div>
                        <div class="ui-g-4">
                          <button
                            pButton
                            type="button"
                            class="ui-button-danger hide"
                            (click)="dissasociateInvoiceAddressOrg($event, item, ia)"
                            icon="pi pi-trash"
                            label="Remove"
                          ></button>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div *ngIf="ia.customerDepartments.length > 0" class="ui-g-12">
                    <span
                      ><b>{{
                        ia.customerDepartments.length > 1 ? 'Departments' : 'Department'
                      }}</b></span
                    >
                    <ul class="progress-step-item style-1">
                      <li
                        class="ui-g-12"
                        *ngFor="let item of ia.customerDepartments; let i = index"
                      >
                        <div class="ui-g-8">{{ item.name }}</div>
                        <div class="ui-g-4">
                          <button
                            pButton
                            type="button"
                            class="ui-button-danger mt-1"
                            (click)="dissasociateInvoiceAddressDept($event, item, ia)"
                            icon="pi pi-trash"
                            label="Remove"
                          ></button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </p-card>
            </div>
          </p-panel>
        </ng-template>
      </p-dataView>
      <p-confirmDialog
        header="Confirmation"
        key="invoice-address-action-dialog"
        icon="fa-icon-circle"
        [style]="{ width: '425px' }"
        acceptLabel="Yes"
        rejectLabel="No"
      ></p-confirmDialog>

      <p-dialog
        ngClass="dialog"
        header="Invoice Address History"
        [(visible)]="showHistory"
        [modal]="true"
        [responsive]="true"
        *ngIf="invoiceAddressHistory"
      >
        <p-table
          [resizableColumns]="true"
          [value]="invoiceAddressHistory"
          *ngIf="invoiceAddressHistory.length > 0"
          [scrollable]="true"
          scrollHeight="400px"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn pSortableColumn="user">User</th>
              <th pResizableColumn pSortableColumn="impersonatingUser">Impersonating User</th>
              <th>Notes</th>
              <th pResizableColumn pSortableColumn="created">Created</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item">
              <td>{{ item.user }}</td>
              <td>{{ item.impersonatingUser }}</td>
              <td>{{ item.note }}</td>
              <td>{{ item.created | datex : 'ddd DD MMM HH:mm' }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!-- DATATABLE DEPRECATED ---
            <p-dataTabl [resizableColumns]="true" [value]="invoiceAddressHistory" *ngIf="invoiceAddressHistory.length>0" [scrollable]="true"
                scrollHeight="400px">
                    <p-column field="user" header="User" [sortable]="tru">

                    </p-column>
                    <p-column field="impersonatingUser" header="Impersonating User" [sortable]="tru">

                    </p-column>
                    <p-column field="note" header="Notes" [sortable]="false" ngClass="typography"></p-column>
                    <p-column field="created" header="Created" [sortable]="tru">
                            <ng-template pTemplate="body" let-item="rowData">
                                    {{item.created | datex:'ddd DD MMM HH:mm'}}
                                </ng-template>
                    </p-column>
                </p-dataTable>
                -->

        <div *ngIf="invoiceAddressHistory.length == 0" ngClass="no-content-dialog">
          No records found
        </div>
        <p-footer>
          <button
            type="button"
            pButton
            icon="pi pi-times"
            (click)="showHistory = false"
            label="Close"
            class="ui-button ui-button-primary"
          ></button>
        </p-footer>
      </p-dialog>
    </div>
  </div>
</div>
